import React from 'react';
import { cn } from './cn';
type Variant = 'primary' | 'secondary' | 'ghost';
type Size = 'sm' | 'md';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
}
const variants: Record<Variant, string> = {
  primary: 'bg-accent text-white hover:bg-accent-soft shadow-[0_0_0_1px_rgba(139,124,255,0.4)]',
  secondary: 'bg-white/[0.06] text-zinc-100 hover:bg-white/[0.12] ring-1 ring-inset ring-white/10',
  ghost: 'text-zinc-300 hover:text-white hover:bg-white/[0.06]'
};
const sizes: Record<Size, string> = {
  sm: 'text-[12.5px] px-3 py-1.5 gap-1.5',
  md: 'text-sm px-4 py-2 gap-2'
};
export function Button({
  variant = 'secondary',
  size = 'md',
  className,
  children,
  ...rest
}: ButtonProps) {
  return <button className={cn('inline-flex items-center justify-center rounded-xl font-medium transition-all duration-150 active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-accent/60 disabled:opacity-50', variants[variant], sizes[size], className)} {...rest} data-id="element-674" data-mp="33tbwp5r8lpy">
      {children}
    </button>;
}